import { useRecoilValue } from "recoil";
import {
  currentPage,
  languageSelected,
  cursusIdSelected,
  cursusFourthYear,
} from "../recoil/Atomes";
import { textTranslation } from "../config/Multilangues";
import { Card } from "react-bootstrap";
import { switchDisplayLogo } from "./Pictures";

// Le component qui définie le parcours réalisé en 4ème par l'étudiant
export const OptionSelected = () => {
  const cursusId = useRecoilValue(cursusIdSelected);
  const cursusFourth = useRecoilValue(cursusFourthYear);
  const current_page = useRecoilValue(currentPage);
  const language = useRecoilValue(languageSelected);

  const valueTextCursus =
    cursusId && current_page > 3
      ? textTranslation[language][cursusId][current_page]
      : textTranslation[language]["general"][current_page]; 

  return (
    <div className="col-sm-12">
      <div className="row text-center px-4">
        <Card className="home-card mt-3 px-3 py-2 fw-bold text-white"
        style={{
          backgroundColor: `${valueTextCursus.options[cursusFourth].background + '99'}`
        }}>
          <Card.Body className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="image-card-bg"
              style={{
                backgroundColor: `${valueTextCursus.options[cursusFourth].background}33`,
              }}>
                <img
                  src={switchDisplayLogo(
                    valueTextCursus.options[cursusFourth].logo
                  )}
                  alt="..."
                  className=""
                />
              </div>
              <Card.Text className="m-0 p-2 w-75 text-start">
                {
                  valueTextCursus.options[cursusFourth].title
                }
              </Card.Text>
            </div>
          </Card.Body>
        </Card>
        {valueTextCursus.options[cursusFourth] &&
        valueTextCursus.options[cursusFourth].paragraph ? (
          <Card className="home-card mt-3 px-3 py-2 fw-bold text-white">
            <Card.Body>
              <Card.Text>
                {
                  valueTextCursus.options[cursusFourth]
                    .paragraph
                }
              </Card.Text>
            </Card.Body>
          </Card>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
